module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 70
    }
  }, [(_vm.competence.length) ? _c('CardtabLayout', _vm._l((_vm.competence), function(item, index) {
    return _c('CompetenceCard', _vm._b({
      key: index
    }, 'CompetenceCard', item, false))
  }), 1) : (!_vm.error) ? _c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "bold, center, uppercase"
    }
  }, [_vm._v("Компетенций нет")]) : _c('AppHeading', {
    attrs: {
      "level": "2",
      "mod": "bold, center, uppercase, red"
    }
  }, [_vm._v("Сбой в работе оборудования")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ca52c0c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/professions/card/competence/Competence.vue
// module id = cc2b9eec374f94f1074c
// module chunks = 60